function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M24.26,44.82l10.51-.08,8.56-13.96-4.73-9.2c-4.03-.78-8.25-.27-12.25.56-1.1.55-7.21,10.25-7.1,11.41.11,1.18,1.57,4.7,2.13,5.96.81,1.85,1.85,3.59,2.89,5.32Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M22.53,54.62c.06-1.61-.08-3.25,0-4.86.05-.87.68-2.9.51-3.55-.08-.3-1.01-1.28-1.29-1.79-1.67-3-3.24-6.15-3.95-9.54l-2.72.61c-1.23,4.95-.3,10.8,1.84,15.43,1.32,2.87,2.04,4.24,5.61,3.71Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M51.36,18.41c2.1,1.22,4.09,3.47,6.49,3.38-.54-1.78-9.47-6.75-10.29-6.11.43,1.81,2.29,1.85,3.8,2.73Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M27.45,59.57c-1.02-.63-3.4-2.91-4.1-3.15-.59-.2-1.75.36-2.49.14-.32.27,1.78,2.24,2.08,2.51,2.77,2.51,6.57,4.49,10.16,5.55.1-.1-1.02-2.45-1.14-2.61-.57-.78-3.45-1.8-4.51-2.45Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M40.13,19.52c1.53-1.22,3.71-1.6,5.28-2.5.26-.15.55-.21.45-.59-.23-2.57-7.36-1.97-9.21-1.78-3.52.37-7.57,2.08-10.48,4l.25,1.49c4.54-1.03,9.1-.81,13.7-.61Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M40.76,57.13l-6.81,4.46c-.3.43,1.89,3.46,2.49,3.73.64.28,3.46.44,4.3.42,3.87-.1,11.64-2.25,14.46-5.01,1.25-1.23.54-2.59-.31-3.87-4.68.79-9.42.59-14.14.27Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M37.3,10.38c-20.79,1.86-33.2,24.59-23.69,43.23,10.72,21.02,40.85,21.6,52.48,1.09,11.9-20.99-4.93-46.45-28.79-44.32ZM64.3,53.69c-10.83,19.1-38.88,18.56-48.86-1.02-8.85-17.36,2.71-38.52,22.06-40.25,22.21-1.98,37.88,21.73,26.8,41.26Z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M63.38,29.21c-1.06-2.32-2.74-6-5.8-5.46.47,1.94-.66,5.35-.21,7.03.17.61,1.51,2.28,1.93,3.08,1.63,3.15,3.22,6.36,3.87,9.89h2.02s.42-.43.42-.43c.36-5.01-.13-9.53-2.23-14.11Z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M44.75,31.99l-8.31,13.86,4.48,9.27c.97.03,1.9.28,2.86.34,2.2.12,10.41.18,11.99-.83,1.05-.67,5.67-8.64,5.66-9.85,0-3.36-3.54-9.34-5.27-12.27-1.52-.08-10.88-1.01-11.43-.52Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

export default __webpack_public_path__ + "static/media/Sports-active.1ae31c8f.svg";
export { SvgComponent as ReactComponent };